import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router-dom";
import { STATUS, INSPECT, SUBMIT } from "../../../src/constants";
//import ShippingRequest from "../shippingRequest";
import { useTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import shipping from "../../redux/shipping";
import { USERROLES } from "../../../src/constants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BasicTabs({ shippingDetails, shippingActionType }) {
  const [value, setValue] = React.useState(0);
  const [unsavedPopupOpen, setUnsavedPopupOpen] = React.useState(false);
  const [pendingTabNavigation, setPendingTabNavigation] = React.useState(null);
  const domBaselineRef = React.useRef({ path: "", hash: "" });
  const userInteractedRef = React.useRef(false);
  const hasUnsavedChangesRef = React.useRef(false);
  const bypassInterceptRef = React.useRef(false);
  const pendingNavElementRef = React.useRef(null);
  const requestTabPaths = [
    "/shipping",
    "/material",
    "/invoice",
    "/reviewerList",
    "/comments",
    "/newShippingComments",
    "/reports",
    "/shipmentdocumentation",
    "/processingdocumentation",
    "/requestByDelegate/edit",
  ];
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { errorTab } = useSelector((state) => state.errors);
  const { navKey } = useSelector((state) => state.navbar);
  const {
    hasUnsavedChanges,
    initialFormValues,
    destinationAddrSelect,
    finalRecipientSelect,
    shipperAddrSelect,
    finalShipperRecipientSelect,
    shippingDeputySelect,
    internalOrderIdValue,
    shipmentSpecificValue,
    shippingCreateDateValue,
    distributionTempValue,
    shippingCreateCommentValue,
    shippingMaterialSelect,
    shippingMaterialSelectedValue,
    materailIdSelect,
    sapDeliveryNumValue,
    dispatchMONValue,
    dispatchLEVValue,
    dateOfReceiptValue,
    trackingNumValue,
    statusQuoValue,
    attachements,
    shipper,
    extra,
  } = useSelector((state) => state[shipping.name]);
  var userType = JSON.parse(localStorage.getItem("userType"));

  const isRequestTabRoute = (pathname) =>
    requestTabPaths.some((path) => pathname === path || pathname.startsWith(`${path}/`));

  const buildDomFormHash = () => {
    const fields = Array.from(document.querySelectorAll("input, select, textarea"));
    const values = fields
      .filter((el) => !el.disabled && !el.readOnly)
      .map((el, index) => {
        const key = el.name || el.id || `field_${index}`;
        let value;
        if (el.type === "checkbox" || el.type === "radio") {
          value = Boolean(el.checked);
        } else {
          value = el.value;
        }

        return `${key}:${String(value)}`;
      })
      .sort();

    return JSON.stringify(values);
  };

  // Keep latest dirty state in a ref so the document-level menu click
  // interceptor (registered once) always reads the current value.
  React.useEffect(() => {
    hasUnsavedChangesRef.current = hasUnsavedChanges;
  }, [hasUnsavedChanges]);

  // Single source of truth for "are there unsaved edits on the current form".
  const isFormDirty = () => {
    const currentPath = window.location.pathname;
    const domChanged =
      !currentPath.startsWith("/material") &&
      userInteractedRef.current &&
      domBaselineRef.current.path === currentPath &&
      domBaselineRef.current.hash !== buildDomFormHash();
    // Delegate edits made on the /addDelegates page are not DOM form fields and
    // may already be folded into the baseline by a later tab mount (which resets
    // the redux unsaved flag). The sessionStorage flag is the durable signal
    // that unsaved delegate changes are still pending for the current request;
    // it is cleared only when the request is saved or the changes are discarded.
    const deputiesPending =
      sessionStorage.getItem("deputiesDirtyRequestId") != null;
    return hasUnsavedChangesRef.current || domChanged || deputiesPending;
  };

  useEffect(() => {
    // Capture baseline form values once request data is present.
    // Request tabs manage their own hydration timing, so avoid taking the
    // generic baseline there before async field sync finishes.
    if (
      !initialFormValues &&
      shippingDetails?.length &&
      !isRequestTabRoute(location.pathname)
    ) {
      dispatch(shipping.actions.storeInitialFormValues());
      dispatch(shipping.actions.setUnsavedChanges(false));
    }
  }, [dispatch, initialFormValues, shippingDetails?.length, location.pathname]);

    // Expose navigateToPath globally so non-tab navigations (e.g. addDelegates)
    // can also trigger the unsaved-changes popup guard.
    useEffect(() => {
      window.__grsmNavigateToPath = (path, tabValue) => navigateToPath(path, tabValue);
      return () => {
        delete window.__grsmNavigateToPath;
      };
    });

  useEffect(() => {
    if (!initialFormValues) return;

    const captureBaseline = () => {
      domBaselineRef.current = {
        path: location.pathname,
        hash: buildDomFormHash(),
      };
      userInteractedRef.current = false;
    };

    const t1 = setTimeout(captureBaseline, 0);
    const t2 = setTimeout(captureBaseline, 300);
    const t3 = setTimeout(captureBaseline, 1000);

    // Any real edit begins with a pointer press or a key press, even for MUI
    // Select/Autocomplete/date pickers that update via their own handlers
    // without emitting native DOM input/change events. Capturing these two
    // events reliably marks genuine user interaction across all control types.
    // Interacting with the tab bar or the confirmation dialog must NOT count as
    // editing the form: otherwise async data hydration after load could be
    // mistaken for a user change the moment the user clicks another tab.
    const markInteracted = (event) => {
      const target = event?.target;
      if (
        target &&
        typeof target.closest === "function" &&
        target.closest(".MuiTabs-root, .MuiDialog-root")
      ) {
        return;
      }
      userInteractedRef.current = true;
    };

    document.addEventListener("pointerdown", markInteracted, true);
    document.addEventListener("keydown", markInteracted, true);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      document.removeEventListener("pointerdown", markInteracted, true);
      document.removeEventListener("keydown", markInteracted, true);
    };
  }, [location.pathname, initialFormValues]);

  // Guard main navbar navigation: if the current request form has unsaved edits
  // and the user clicks another menu item, show the same confirmation popup used
  // for tab switches instead of navigating away and losing the changes.
  useEffect(() => {
    const handleMenuClickCapture = (event) => {
      // Allow the programmatic re-dispatch triggered after the user confirms.
      if (bypassInterceptRef.current) {
        bypassInterceptRef.current = false;
        return;
      }

      const anchor = event.target?.closest?.("a.nav-link, a.dropdown-item");
      if (!anchor || anchor.classList.contains("dropdown-toggle")) return;
      if (!isFormDirty()) return;

      // Block the navigation and its side effects, then prompt the user.
      event.preventDefault();
      event.stopPropagation();
      pendingNavElementRef.current = anchor;
      setUnsavedPopupOpen(true);
    };

    document.addEventListener("click", handleMenuClickCapture, true);
    return () => document.removeEventListener("click", handleMenuClickCapture, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!initialFormValues) return;
    dispatch(shipping.actions.checkFormDirtyState());
  }, [
    dispatch,
    initialFormValues,
    destinationAddrSelect,
    finalRecipientSelect,
    shipperAddrSelect,
    finalShipperRecipientSelect,
    shippingDeputySelect,
    internalOrderIdValue,
    shipmentSpecificValue,
    shippingCreateDateValue,
    distributionTempValue,
    shippingCreateCommentValue,
    shippingMaterialSelect,
    shippingMaterialSelectedValue,
    materailIdSelect,
    sapDeliveryNumValue,
    dispatchMONValue,
    dispatchLEVValue,
    dateOfReceiptValue,
    trackingNumValue,
    statusQuoValue,
    attachements,
    shipper,
    extra,
  ]);

  useEffect(() => {
    if (location.pathname === "/material") {
      setValue(1);
    } else if (location.pathname === "/reviewerList") {
      setValue(2);
    } else if (location.pathname === "/invoice") {
      setValue(3);
    } else if (location.pathname === "/reports") {
      setValue(4);
    } else if (location.pathname === "/comments") {
      setValue(5);
    } else if (location.pathname === "/newShippingComments") {
      setValue(5);
    } else if (location.pathname === "/shipmentdocumentation") {
      setValue(6);
    } else if (location.pathname === "/processingdocumentation") {
      setValue(7);
    } else {
      setValue(0);
    }
  }, [location.pathname]);

  const navigateToPath = (path, tabValue) => {
    if (location.pathname === path) {
      if (tabValue !== null) setValue(tabValue);
      return;
    }

    // Compare the current visible-form hash against the captured baseline.
    // This works for every route (including request tabs) and reliably reflects
    // MUI control values via their underlying inputs. Gated by real user
    // interaction so async data hydration on load never triggers a false popup.
    // Material tab has explicit dirty tracking for local edit/new fields.
    // Avoid DOM-hash fallback there to prevent false positives from
    // Autocomplete input/display-only updates.
    const useDomDirtyFallback = !location.pathname.startsWith("/material");
    const domChanged =
      useDomDirtyFallback &&
      userInteractedRef.current &&
      domBaselineRef.current.path === location.pathname &&
      domBaselineRef.current.hash !== buildDomFormHash();

    if (hasUnsavedChanges || domChanged || isFormDirty()) {
      setPendingTabNavigation({ path, tabValue });
      setUnsavedPopupOpen(true);
      return;
    }

    if (tabValue !== null && tabValue !== undefined) setValue(tabValue);
    history.push(path);
  };

  const handleCloseUnsavedPopup = () => {
    setUnsavedPopupOpen(false);
    setPendingTabNavigation(null);
    pendingNavElementRef.current = null;
  };

  const handleSaveAndContinue = async () => {
    const saveHandler = window.__grsmSaveBeforeTabChange;
    if (typeof saveHandler === "function") {
      const canContinue = await saveHandler();
      if (canContinue === false) {
        return;
      }
    }

    if (!pendingTabNavigation) {
      handleCloseUnsavedPopup();
      return;
    }

    setUnsavedPopupOpen(false);
    if (pendingTabNavigation.tabValue !== null && pendingTabNavigation.tabValue !== undefined) {
      setValue(pendingTabNavigation.tabValue);
    }
    history.push(pendingTabNavigation.path);
    setPendingTabNavigation(null);
  };

  const handleDiscardAndContinue = () => {
    // Clear the deputies dirty flag so the restored baseline is used on reload.
    sessionStorage.removeItem("deputiesDirtyRequestId");
    dispatch(shipping.actions.resetFormToInitialValues());
    dispatch(shipping.actions.setUnsavedChanges(false));
    hasUnsavedChangesRef.current = false;
    userInteractedRef.current = false;

    // Navigation intercepted from the main navbar: re-dispatch the original
    // click so its own handlers (redux updates, routing) run naturally now that
    // the form is no longer dirty.
    if (pendingNavElementRef.current) {
      const anchor = pendingNavElementRef.current;
      pendingNavElementRef.current = null;
      setUnsavedPopupOpen(false);
      bypassInterceptRef.current = true;
      anchor.click();
      return;
    }

    if (!pendingTabNavigation) {
      handleCloseUnsavedPopup();
      return;
    }

    setUnsavedPopupOpen(false);
    if (pendingTabNavigation.tabValue !== null && pendingTabNavigation.tabValue !== undefined) {
      setValue(pendingTabNavigation.tabValue);
    }
    history.push(pendingTabNavigation.path);
    setPendingTabNavigation(null);
  };

  const renderTabs = () => {
    if (shippingActionType !== INSPECT && shippingActionType !== SUBMIT) {
      return [
        <Tab
          key="shipping"
          label={t("shipping_request.shipping_request")}
          style={
            errorTab === 1 || errorTab === 3
              ? { textTransform: "none", border: "1px solid red" }
              : { textTransform: "none" }
          }
          index={0}
          value={0}
          onClick={() => navigateToPath("/shipping", 0)}
        />,
        <Tab
          key="material"
          label={t("navbar.material")}
          style={
            errorTab === 2 || errorTab === 3
              ? { textTransform: "none", border: "1px solid red" }
              : { textTransform: "none" }
          }
          value={1}
          index={1}
          onClick={() => navigateToPath("/material", 1)}
        />,
        shippingDetails?.length &&
        ![
          STATUS.INPUT,
          STATUS.REGULATORY_REVIEWER_1,
          STATUS.REGULATORY_REVIEWER_2,
        ].includes(shippingDetails[0]?.status) && (
          <Tab
            key="invoice"
            label={t("navbar.invoice")}
            style={{ textTransform: "none" }}
            value={3}
            index={3}
            onClick={() => navigateToPath("/invoice", 3)}
          />
        ),
        <Tab
          key="reviewer"
          label={t("navbar.Reviewer")}
          style={{ textTransform: "none" }}
          value={2}
          index={2}
          onClick={() => navigateToPath("/reviewerList", 2)}
        />,
        shippingDetails?.length &&
        ![
          STATUS.INPUT,
          STATUS.REGULATORY_REVIEWER_1,
          STATUS.REGULATORY_REVIEWER_2,
        ].includes(shippingDetails[0]?.status) && (
          <Tab
            key="reports"
            label="Reports"
            style={{ textTransform: "none" }}
            value={4}
            index={4}
            onClick={() => navigateToPath("/reports", 4)}
          />
        ),
        shippingDetails?.length && (
          <Tab
            key="comments"
            label={t("comments_alert.comments")}
            style={{ textTransform: "none" }}
            value={5}
            index={5}
            onClick={() => navigateToPath("/comments", 5)}
          />
        ),
        shippingDetails?.length === 0 && (
          <Tab
            key="newComments"
            label={t("comments_alert.comments")}
            style={{ textTransform: "none" }}
            value={5}
            index={5}
            onClick={() => navigateToPath("/newShippingComments", 5)}
          />
        ),
        shippingDetails?.length > 0 && navKey === 'PROCESS_SHIPPING_REQUESTS' && (
          <Tab
            key="shipmentDoc"
            label={t("reports.shipping_documentation_nav_header")}
            style={{ textTransform: "none" }}
            value={6}
            index={6}
            onClick={() => navigateToPath("/shipmentdocumentation", 6)}
          />
        ),
        shippingDetails?.length > 0 && navKey === 'PROCESS_SHIPPING_REQUESTS' &&
        (userType.includes(USERROLES.SYSTEMADMINISTRATOR) === true || userType.includes(USERROLES.PROCESSMANAGER) === true) && (
          <Tab
            key="processingDoc"
            label={t("reports.processing_documentation_nav_header")}
            style={{ textTransform: "none" }}
            value={7}
            index={7}
            onClick={() => navigateToPath("/processingdocumentation", 7)}
          />
        ),
      ].filter(Boolean);
    } else if (shippingActionType === INSPECT || shippingActionType === SUBMIT) {
      return [
        <Tab
          key="shipping2"
          label={t("shipping_request.shipping_request")}
          style={
            errorTab === 1 || errorTab === 3
              ? { textTransform: "none", border: "1px solid red" }
              : { textTransform: "none" }
          }
          index={0}
          value={0}
          onClick={() => navigateToPath("/shipping", 0)}
        />,
        <Tab
          key="material2"
          label={t("navbar.material")}
          style={
            errorTab === 2 || errorTab === 3
              ? { textTransform: "none", border: "1px solid red" }
              : { textTransform: "none" }
          }
          value={1}
          index={1}
          onClick={() => navigateToPath("/material", 1)}
        />,
        <Tab
          key="reviewer2"
          label={t("navbar.Reviewer")}
          style={{ textTransform: "none" }}
          value={2}
          index={2}
          onClick={() => navigateToPath("/reviewerList", 2)}
        />,
        shippingDetails?.length && (
          <Tab
            key="comments2"
            label={t("comments_alert.comments")}
            style={{ textTransform: "none" }}
            value={5}
            index={5}
            onClick={() => navigateToPath("/comments", 5)}
          />
        ),

        shippingDetails?.length === 0 && (
          <Tab
            key="newComments2"
            label={t("comments_alert.comments")}
            style={{ textTransform: "none" }}
            value={5}
            index={5}
            onClick={() => navigateToPath("/newShippingComments", 5)}
          />
        ),
        shippingDetails?.length > 0 && (shippingDetails[0].status === STATUS.READY_FOR_DELIVERY ||
          shippingDetails[0].status === STATUS.IN_DELIVERY) && (
          <Tab
            key="shipmentDoc2"
            label={t("reports.shipping_documentation_nav_header")}
            style={{ textTransform: "none" }}
            value={6}
            index={6}
            onClick={() => navigateToPath("/shipmentdocumentation", 6)}
          />
        ),
        shippingDetails?.length > 0 && (navKey === 'PROCESS_SHIPPING_REQUESTS' || navKey === 'ADMINISTRATION_SHIPPING_REQUEST') &&
        (userType.includes(USERROLES.SYSTEMADMINISTRATOR) === true || userType.includes(USERROLES.PROCESSMANAGER) === true) &&
        (shippingDetails[0].status === STATUS.READY_FOR_DELIVERY ||
          shippingDetails[0].status === STATUS.IN_DELIVERY ||
          shippingDetails[0].status === STATUS.CANCELLED ||
          shippingDetails[0].status === STATUS.INBOX ||
          shippingDetails[0].status === STATUS.INPUT ||
          shippingDetails[0].status === STATUS.REGULATORY_REVIEWER_1 ||
          shippingDetails[0].status === STATUS.REGULATORY_REVIEWER_2 ||
          shippingDetails[0].status === STATUS.AWAITING_FOR_APPROVAL) && (
          <Tab
            key="processingDoc2"
            label={t("reports.processing_documentation_nav_header")}
            style={{ textTransform: "none" }}
            value={7}
            index={7}
            onClick={() => navigateToPath("/processingdocumentation", 7)}
          />
        ),
      ].filter(Boolean);
    }
  };

  const tabs = renderTabs();

  // Don't render anything if there are no tabs
  if (!tabs || tabs?.length === 0) {
    return null;
  }

  // Clamp value to valid tab indices to prevent MUI scrollTop null error
  const validTabValues = tabs?.map((tab) => tab?.props?.value);
  const safeValue = validTabValues?.includes(value) ? value : validTabValues[0] ?? 0;

  return (
    <>
      <Box sx={{ width: "100%" }}>
        {tabs?.length > 0 && (
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              key={`${tabs.length}-${location.pathname}`} // Force remount Tabs when number of tabs or path changes to reset internal state and prevent MUI scrollTop null error
              value={safeValue}
              aria-label="tabs"
              scrollButtons="auto"
              variant="scrollable"
              allowScrollButtonsMobile
            >
              {tabs}
            </Tabs>
          </Box>
        )}
      </Box>
      <Dialog open={unsavedPopupOpen} onClose={handleCloseUnsavedPopup}>
        <DialogTitle>{t("commonlabels.confirmation")}</DialogTitle>
        <DialogContent>
          {t("commonlabels.unSavedDescription")}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDiscardAndContinue} variant="outlined" size="small">
            {t("commonlabels.discardChanges")}
          </Button>
          <Button onClick={handleCloseUnsavedPopup} size="small">
            {t("commonlabels.stayOnPage")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  redirectTo: state[shipping.name].redirectTo,
  shippingDetails: state[shipping.name].shippingRequestDetails,
  shippingActionType: state[shipping.name].shippingActionType,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BasicTabs);